<template>
    <div>
        <el-dialog
                :title="title"
                :visible="showSerial"
                :close-on-click-modal="!showSerial"
                :before-close="close"
                width="600px"
        >
            <div class="Field">
                <el-form ref="form" :model="StageModel" label-width="120px" :rules="rules">
                    <el-form-item label="所属领域" prop="productDomainId">
                        <el-select v-model="StageModel.productDomainId" placeholder="请选择" disabled filterable  @change="getdropList(1,StageModel.productDomainId)" style="width:410px">
                            <el-option v-for="item in fieldLevel" :key="item.id" :label="item.name" :value="item.id" >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属一级产品" prop="firstProductId">
                        <el-select  v-model="StageModel.firstProductId" placeholder="请选择" filterable style="width:410px">
                            <el-option v-for="item in oneLevel" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务类型名称" prop="serviceStageName" class="m-t-20">
                        <el-input type="text" v-model.trim="StageModel.serviceStageName" maxlength="100" placeholder="请输入服务类型名称，不超过100字" class="edit_input" style="width: 410px"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                    <el-button type="primary" @click="push('form')">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getproSelect,addStage } from "@/service/dataFrame";
    import { getStorageUserRoleId } from '@/utils/store'
    export default {
        name: "addStage",
        props: {
            title: {
                type: String,
                default: "新增产品系列",
            },
        },
        data(){
            return{
                showSerial:true,
                StageModel:{
                    productDomainId:'',
                    firstProductId:'',
                    serviceStageName:''
                },
                fieldLevel:[],
                oneLevel:[],
                rules:{
                    productDomainId: [{required:true, message: '请选择领域名称！', trigger: 'change'}],
                    firstProductId: [{required:true, message: '请选择所属一级产品！', trigger: 'change'}],
                    serviceStageName: [{required:true, message: '请输入服务类型名称！', trigger: 'blur'}],
                }
            }
        },
        methods:{
            close(){
                this.$emit("close")
            },
            push(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let param={
                            productDomainId:this.StageModel.productDomainId,
                            firstProductId:this.StageModel.firstProductId,
                            serviceStageName:this.StageModel.serviceStageName,
                            userId:getStorageUserRoleId()
                        }
                        console.log("param",param)
                        addStage(param).then((res)=>{
                            if(res.Result != 1) {
                                return this.$message.error(res.Message)
                            }
                            this.$emit("close")
                            this.$message.success("新增成功")
                            this.$emit("refreshList")
                        })
                    }
                })
            },
            getdropList(data,updata){
                let param={
                    levelType:data
                }
                if(data>0){
                    param.superiorId=updata
                }
                getproSelect(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    if(data==0){
                        this.fieldLevel=res.Data;
                        this.StageModel.productDomainId = this.fieldLevel[0].id
                        this.getdropList(1,this.StageModel.productDomainId)
                    }
                    if(data==1){
                        this.oneLevel=res.Data;
                        this.StageModel.firstProductId='';
                    }
                })
            },
        },
        mounted() {
            this.getdropList(0,0);
        }
    }
</script>

<style lang="scss">
    .m-t-20{
        margin-top: 20px;
    }
</style>
